export const hasToken = () => !!localStorage.getItem("token");
